import React from 'react';

interface IProps {
  text: string,
  linkTo: string,
  linkTitle: string,
}

const EmptyMessageWithLink = ({ text, linkTo, linkTitle }: IProps) => (
  <p>
    { text }&nbsp;
    <a target="_blank" href={ linkTo }>
      { linkTitle }
    </a>.
  </p>
);

export default EmptyMessageWithLink;
